import { Injectable } from "@angular/core";
import { EmailQuote, PurchaseData, Agent, FeatureService } from "../shared";
import { BhtpBaseService, ApiQuoteResponse } from "@bhtp-client-api/base";
import { ModalService } from "@bhtp-client-web/component";
import { Http, RequestOptions } from "@angular/http";
import { InsuredEventMapperV2 } from "../shared/helpers/insured-event.mapper-v2";
import { GWInsuredEvent } from "../shared/models/agents-gateway/save-quote/gw-insured-event.model";
import { GWCreateInsuredEventRequest } from "../shared/models/agents-gateway/save-quote/gw-create-insured-event-request.model";
import { GatewayErrorResponse } from "../shared/models/agents-gateway/errors/gateway-error-reesponse.model";
import { GWEmailQuoteRequest } from "../shared/models/agents-gateway/save-quote/gw-email-quote-request.model";
import { EmailQuoteData } from ".";
import { FeatureToggles } from "../shared/models/agents-gateway/save-quote/feature-toggles.enum";
import { GWAttribute } from "../shared/models/agents-gateway/save-quote/gw-attribute.model";

// Will be completed with email a quote work
@Injectable()
export class EmailQuoteService extends BhtpBaseService {
    constructor(private http: Http, private insuredEventMapper: InsuredEventMapperV2, private featureService: FeatureService) {
        super();
    }

    public async convertAndEmailQuote(
            purchaseData: PurchaseData,
            quote: ApiQuoteResponse,
            emailQuote: EmailQuoteData,
            agent: Agent): Promise<void> {
        const request: GWEmailQuoteRequest = new GWEmailQuoteRequest();
        request.event = this.convertPurchaseDataAndQuoteToEvent(purchaseData, [quote]);
        request.email = emailQuote.primaryEmail;
        request.message = emailQuote.comment;
        request.agentCode = agent.agentCode;
        request.agentName = agent.name;
        request.event.quotes[0].selected = true;

        this.addAttributesAndFeatureToggles(request);
        await this.emailQuote(request);
    }

    public async convertAndEmailQuickQuotes(
            purchaseData: PurchaseData,
            quotes: ApiQuoteResponse[],
            emailQuote: EmailQuoteData,
            agent: Agent
            ): Promise<void> {
        const request: GWEmailQuoteRequest = new GWEmailQuoteRequest();
        request.event = this.convertPurchaseDataAndQuoteToEvent(purchaseData, quotes);
        request.email = emailQuote.primaryEmail;
        request.message = emailQuote.comment;
        request.agentCode = agent.agentCode;
        request.agentName = agent.name;

        for (let i: number = 0; i <= quotes.length - 1; i++) {
            request.event.quotes[i].selected = true;
        }

        this.addAttributesAndFeatureToggles(request);
        await this.emailQuote(request);
    }

    public async emailQuote(request: GWEmailQuoteRequest) {
        let path: string = this.getFullUrl('/quote/email');
        let options: RequestOptions = this.getStandardRequestOptions();
        this.addAuthorizationToken(options);
        try {
            let response: any = await this.http.post(path, request, options).toPromise();
        } catch (err) {
            this.handleGatewayError(err);
        }
    }

    private addAttributesAndFeatureToggles(request: GWEmailQuoteRequest): void {
        // Add attributes to event
        if (!request.event.attributes) {
            request.event.attributes = [];
        }
        request.event.attributes.push(new GWAttribute('saveMethod', 'Quote(s) Emailed'));

        // Add attributes to each quote
        if (request.event.quotes) {
            request.event.quotes.forEach(quote => {
                if (!quote.attributes) {
                    quote.attributes = [];
                }
                quote.attributes.push(new GWAttribute('saveMethod', 'Quote(s) Emailed'));
            });
        }

        if (this.featureService.isEventIdAsQuoteNumberEnabled()) {
            const toggle = new FeatureToggles();
            toggle.name = 'featureToggleQuoteNumber';
            toggle.isEnabled = true;
            request.featureToggles = [toggle];
        }
    }

    private convertPurchaseDataAndQuoteToEvent(data: PurchaseData, quotes: ApiQuoteResponse[]): GWInsuredEvent {
        return this.insuredEventMapper.mapPurchaseDataAndQuoteToInsuredEvent(data, quotes);
    }

    private handleGatewayError(err: any) {
        let errorToThrow: GatewayErrorResponse;
        const body = err._body;
        if (body) {
            errorToThrow = JSON.parse(body);
        }
        else {
            errorToThrow = {
                message: 'Unknown Error',
                name: 'UNKNOWN_ERROR',
                validationMessages: []
            };
        }
        throw errorToThrow;
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/email-quote/email-quote.service.ts